import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import {
  DocketSettingsRootParamList,
  EditDocketTemplateRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import React from "react";

import { DocketTemplateFormProvider } from "../../components/DocketTemplateForm/DocketTemplateFormProvider";
import { ManageDocketTemplateScreenContext } from "../ManageDocketTemplateRootScreen/context";
import { ManageDocketTemplateRootScreen } from "../ManageDocketTemplateRootScreen";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";

const Stack = createStackHeaderNavigator<EditDocketTemplateRootParamList>();

export interface CreateDocketTemplateRootScreenProps
  extends StackScreenProps<
    DocketSettingsRootParamList,
    "CreateDocketTemplateRootScreen"
  > {}

export const CreateDocketTemplateRootScreen = ({
  navigation,
}: CreateDocketTemplateRootScreenProps) => {
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const onAfterSubmitCallback = React.useCallback(async () => {
    await fetchAndSyncEntity("docket_templates");
    navigation.pop();
  }, []);

  return (
    <ManageDocketTemplateScreenContext.Provider
      value={{ onAfterSubmit: onAfterSubmitCallback }}
    >
      <DocketTemplateFormProvider
        defaultFormValues={{
          name: "",
          enabled: true,
          defaultTemplateTypeId: undefined,
          filters: [],
          automaticallyPrint: false,
          terminalIds: [],
        }}
      >
        <Stack.Navigator
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerShown: false,
          }}
        >
          <Stack.Screen
            name="ManageDocketTemplateRootScreen"
            component={ManageDocketTemplateRootScreen}
          />
        </Stack.Navigator>
      </DocketTemplateFormProvider>
    </ManageDocketTemplateScreenContext.Provider>
  );
};
